
var tooltipLess = {};
import genaration from '../../utils/classname';
export var tooltipClass = genaration(tooltipLess, 'tooltip');